"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _IconGmail = _interopRequireDefault(require("../../icons/Logos/IconGmail"));
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GoogleButton = ({
  disabled,
  onClick
}) => {
  // Intercept click to handle disabled state
  const handleClick = event => {
    if (disabled) {
      event.preventDefault();
    } else if (onClick) {
      onClick(event);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.GButton, {
    disabled: disabled,
    onClick: handleClick,
    "aria-label": "Google-button",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_IconGmail.default, {}), "Logg p\xE5 med Google"]
  });
};
var _default = exports.default = GoogleButton;